import { memo } from 'radash';

export const parseURL = memo((urlString?: string | null): [Error, null] | [null, URL] => {
  if (!urlString) {
    return [new Error('URL is required'), null];
  }

  try {
    const url = new URL(urlString);
    return [null, url];
  } catch {
    return [new Error('Invalid URL'), null];
  }
});
